import React from "react";
import Seo from "../components/site/Seo";
import HeroSequence from "../components/site/HeroSequence";
import WhoWeAre from "../components/home/WhoWeAre";
import CollaborationBand from "../components/home/CollaborationBand";
import Verticals from "../components/home/Verticals";
import FeaturedWork from "../components/home/FeaturedWork";
import Approach from "../components/home/Approach";
import WhyLykit from "../components/home/WhyLykit";
import Founders from "../components/home/Founders";
import SocialImpactBand from "../components/home/SocialImpactBand";
import ClosingCTA from "../components/home/ClosingCTA";
import { SEO } from "../lib/content";

export default function Home() {
  return (
    <>
      <Seo title={SEO.home.title} description={SEO.home.description} path="/" />
      <HeroSequence />
      <WhoWeAre />
      <CollaborationBand />
      <Verticals />
      <FeaturedWork />
      <Approach />
      <WhyLykit />
      <Founders />
      <SocialImpactBand />
      <ClosingCTA />
    </>
  );
}
